import Router from '../../router';
import {userService} from "../../services";

// initial state
const state = {
    user_loaded: false,
    authenticated: false,
    authenticated_checked: false,
    authenticated_user: {
        email: '',
        connected_account_is_temp: false
    },
    loading: false,
    confirm_code: undefined,
    confirm_code_other: undefined,
    invalid_username_password: false,
    invalid_username_password_message: null,
    invalid_username: false,
    create_account_problem: false,
    create_account_problem_msg: '',
};

// getters
const getters = {};

// internal path requested via ?next= (e.g. /vclanitev); external urls are ignored.
function nextFromRoute() {
    const next = Router.currentRoute.query.next;
    if (typeof next === 'string' && next.startsWith('/') && !next.startsWith('//')) {
        return next;
    }
    return null;
}

// actions
const actions = {
    login({dispatch, commit}, {username, password, document_type}) {
        commit('setActionLoading', true);
        commit('setInvalidUsernamePassword', {
            status: false,
            message: null
        });
        userService.login(username, password, document_type).then(
            data => {

                if (data.old){
                    // flow for old users to migrate to new login system.
                     if (data.card) {
                         Router.push('/prva-prijava-kartica')
                     } else {
                         Router.push('/prva-prijava')
                     }
                } else {
                    commit('setAuthenticated', true);
                    commit('setAuthenticatedUser', data['user']);
                    const next = nextFromRoute();
                    if (next) {
                        Router.push(next);
                    } else if (data.redirect) {
                        dispatch('application/redirect', {
                            url: data.redirect,
                            internal: data.redirect_internal || false,
                            message: ''
                        }, {root: true})
                    } else {
                        Router.push('/racun');
                    }
                }
            },
            error => {
                commit('setAuthenticated', false);
                if (error) {
                    commit('setInvalidUsernamePassword', {
                        status: true,
                        message: error.message
                    });
                }
            }
        ).then(function () {
            commit('setActionLoading', false);
        });
    },
    logout({dispatch, commit}) {
        userService.logout().then(
            data => {
                window.location.replace('/');
            },
            error => {
                window.location.replace('/');
            }
        )
    },
    me({dispatch, commit}, {redirectTo}) {
        userService.me().then(
            data => {
                commit('setAuthenticated', data.authenticated);
                commit('setAuthenticatedUser', data['user']);
                if (data.authenticated){
                    if (redirectTo){
                        Router.push(redirectTo);
                    } else {
                        if (data.redirect) {
                            dispatch('application/redirect', {
                                url: data.redirect,
                                internal: data.redirect_internal || false,
                                message: ''
                            }, {root: true})
                        } else {
                            if (Router.currentRoute.name == 'login') {
                                Router.push(nextFromRoute() || '/racun');
                            }
                        }
                    }
                }
            },
            error => {
                commit('setAuthenticated', false);
            }
        ).then(function () {
            commit('setAuthenticatedChecked', true);
        });
    },
    forgotPassword({dispatch, commit}, {username}) {
        commit('setActionLoading', true);
        commit('setInvalidUsername', false);
        userService.forgotPassword(username).then(
            data => {
                dispatch('application/emailSentMessage', {
                    title: 'Preverite vaš e-mail nabiralnik in potrdite spremembo gesla',
                    text: 'Na e-naslov "'+username+'" smo vam poslali email, v katerem se nahaja povezava za potrditev spremembe gesla'
                }, {root: true});
            },
            error => {
                commit('setInvalidUsername', true);
            }
        ).then(function () {
            commit('setActionLoading', false);
        });
    },
    resetPassword({dispatch, commit}, {password}){
        commit('setActionLoading', true);
        userService.resetPassword(password, this.state.auth.confirm_code).then(
            data => {
                Router.push('login');
            },
            error => {

            }
        ).then(function () {
            commit('setActionLoading', false);
        });
    },
    createAccount({dispatch, commit}, {username, password, name}){
        commit('setActionLoading', true);
        userService.createAccount(username, password, name).then(
            data => {
                Router.push('/poslan-email');
            },
            error => {
                commit('setCreateAccountProblem', error.message)
            }
        ).then(function(){
            commit('setActionLoading', false);
        });
    }
};

// mutations
const mutations = {
    setActionLoading(state, status) {
        state.loading = status;
    },
    setAuthenticatedChecked(state, status) {
        state.authenticated_checked = status;
    },
    setAuthenticated(state, status) {
        state.user_loaded = true;
        state.authenticated = status;
        if (!status){
            state.authenticated_user = {};
        }
    },
    setAuthenticatedUser(state, user) {
        if (!user){
            user = {}
        }
        state.authenticated_user = user;
    },
    setInvalidUsernamePassword(state, {status, message}) {
        state.invalid_username_password = status;
        state.invalid_username_password_message = message;
    },
    setInvalidUsername(state, status) {
        state.invalid_username = status;
    },
    setConfirmCode(state, confirmCode){
        state.confirm_code = confirmCode;
    },
    setConfirmCodeOtherData(state, data){
        state.confirm_code_other = data;
    },
    setCreateAccountProblem(state, message){
        if (message != null){
            state.create_account_problem = true;
        } else {
            state.create_account_problem = false;
        }
        state.create_account_problem_msg = message;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
